import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    title: {
        id: "classroom-closed.title",
    },
    again: {
        id: "classroom-closed.again",
    },
});

export default messages;
